export default __webpack_public_path__ + "82a3e5a9b12640cfdc05499a5c13f72e.png";